import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AuthStatusStage, Navigation } from '@quizzach/components';
import { AuthPage, AuthStatus, BtnTeal } from '@quizzach/styles';
import { IcCheck } from '@quizzach/assets';
import { RoutePath } from '@quizzach/interfaces';
import { useActivateAccount } from '@quizzach/api-hooks';
import { scrollToTop } from '@quizzach/utils';

export const ActivateAccount = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { loading, error, activateAccount } = useActivateAccount();

	useEffect(() => {
		scrollToTop();
		//TODO: treba popraviti kod tako da se ova komponenta ne renderira dvaput, izbjeci react strict mode rerender
		activateAccount();
	}, []);

	return (
		<AuthPage data-id='activate-account-container'>
			<Navigation />

			<AuthStatus>
				{loading ? (
					<div className='stage'>
						<span className='wmk' aria-hidden>
							{t('auth.stage.watermark')}
						</span>
					</div>
				) : (
					<AuthStatusStage
						hand={t(
							error ? 'auth.status.error.hand' : 'auth.status.activated.hand'
						)}
						title={t(
							error ? 'auth.activate.errorTitle' : 'auth.activate.successTitle'
						)}
					/>
				)}

				<div className='formcol'>
					<div className='inner'>
						{loading && (
							<>
								<div className='skel t'></div>
								<div className='skel'></div>
								<div className='skel' style={{ width: '70%' }}></div>
							</>
						)}

						{!loading && error && (
							<>
								<p>{t('auth.activate.errorInfo')}</p>
								<p className='mut'>
									{t('auth.activate.contactUsBefore')}{' '}
									<a href='mailto:team@quizzach.com'>team@quizzach.com</a>
									{t('auth.activate.contactUsAfter')}
								</p>
							</>
						)}

						{!loading && !error && (
							<div className='done'>
								<div className='okrow' style={{ marginBottom: '18px' }}>
									<span className='oktick'>
										<IcCheck size={20} />
									</span>
									<p>{t('auth.activate.successInfo')}</p>
								</div>
								<BtnTeal
									type='button'
									onClick={() => navigate(RoutePath.Login)}
									className='ok-button'
								>
									{t('auth.activate.go')}
								</BtnTeal>
							</div>
						)}
					</div>
				</div>
			</AuthStatus>
		</AuthPage>
	);
};
